import {CloudName, CloudType, Environment} from '@q9elements/ui-kit/common';

export const environment: Environment = {
    production: true,
    CLOUD_NAME: CloudName.ELEMENTS,
    CLOUD_TYPE: CloudType.PUBLIC,
    ENV: 'loadtest',
    API_ENDPOINT: 'https://loadtest-api.q9elements.com/api/v1',
    API_STATIC_FILE_UPLOAD: 'https://loadtest-upload.q9elements.com:1443/api', 
    MAIN_APP_URL: 'https://loadtest-app.q9elements.com',
    DIAGRAM_URL: 'https://loadtest-diagram.q9elements.com',
    REPORTS_API_ENDPOINT: 'https://loadtest-gateway.q9elements.com/report/api/v1',
    ANALYSIS_API: 'https://loadtest-gateway.q9elements.com/dependency-analysis/api/v1/dependency-analysis',
    REPORTS_APP: 'https://loadtest-report.q9elements.com',
    TEAM_APP: 'https://loadtest-spacemgt.q9elements.com',
    REF_MODEL_APP: 'https://loadtest-refmodel.q9elements.com',
    DOMAIN: 'q9elements.com',
    INTERCOM_APP_ID: 'sfi4u1en',
    GA_ID: '',
    version: require('../../package.json').version,
    SENTRY_AUTH_TOKEN: '',
    SENTRY_DSN: '',
    SENTRY_ORG: '',
    SENTRY_PROJECT: 'refmodel-app',
    DATA_STRUCTURE_URL: 'https://loadtest-datatable.q9elements.com',
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    JAM_TEAM_ID: '',
    MCP_OAUTH_URL: 'https://loadtest-api.q9elements.com/api/v1/oauth',
    fbConfig: {
        apiKey:'AIzaSyC1scjCnEIl0p3hNSXPd7xv0gZInlcwr6M',
        authDomain:'elements-loadtest.firebaseapp.com',
        databaseURL: 'https://elements-loadtest-default-rtdb.firebaseio.com/',
        storageBucket: '',
        messagingSenderId: '',
        projectId: 'elements-loadtest',
        appId: '1:201990050997:web:3b9c59c614dcc81aea1afc',
        measurementId:''
    }
};                     
